import { gql } from "lib/apolloClient";

export const updateSchoolLoginConfigMutation = gql`
  mutation upsertSchoolLoginConfig($input: SchoolLoginConfigInput!) {
    organizationManagement {
      upsertSchoolLoginConfig(input: $input) {
        isSuccess
        data {
          id
          organizationId
          logoUrl
          displayName
          schoolCode
        }
        message
      }
    }
  }
`;
